/**
 * Resolve a checkpoint-like object into lat/lng from common field variants.
 * @param {object} stop
 * @returns {{lat: number, lng: number}|null}
 */
export const getLatLng = (stop = {}) => {
  const lat = Number.parseFloat(
    stop?.lat ?? stop?.latitude ?? stop?.coords?.[0] ?? stop?.coordinates?.[0] ?? stop?.location?.lat,
  );
  const lng = Number.parseFloat(
    stop?.lng ??
      stop?.longitude ??
      stop?.coords?.[1] ??
      stop?.coordinates?.[1] ??
      stop?.location?.lng,
  );
  if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
  return null;
};

/**
 * Format resolved coordinates as fixed precision.
 * @param {object} stop
 * @returns {string}
 */
export const formatLatLng = (stop = {}) => {
  const latLng = getLatLng(stop);
  if (!latLng) return 'N/A';
  return `${latLng.lat.toFixed(5)}, ${latLng.lng.toFixed(5)}`;
};
